<template>
  <v-stepper v-model="e6" color="blue lighten-2" vertical>
    <v-stepper-step :complete="e6 > 1" step="1">
      افزودن شماره
      <small>وارد کردن شماره و دریافت کد تایید</small>
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" lg="4" md="6">
          <v-text-field v-model="phone" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable dense
                        label="شماره همراه" outlined placeholder="مانند: 09123456789" @keydown.enter="sendOtp"/>
        </v-col>
        <v-col class="pa-2" cols="12" lg="4" md="6">
          <v-text-field v-model="nationalCode" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable dense
                        label="کد ملی" outlined placeholder="کد ملی" @keydown.enter="sendOtp"/>
        </v-col>

        <v-col class="pa-2" cols="12">
          <v-btn :disabled="!phone || phone.length < 11 || phone.length > 11 || !phone.startsWith('09')"
                 :loading="loading" class="rounded-lg btn-get-code ma-0" depressed @click="sendOtp">
            دریافت کد
          </v-btn>
        </v-col>
      </v-row>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 2" step="2">
      تایید شماره با کد ارسال شده
    </v-stepper-step>
    <v-stepper-content step="2">
      <v-row class="flex-column" no-gutters>
        <v-col class="pa-2" cols="12" lg="4" md="6">
          <v-text-field v-model="phone" class="rounded-lg" dense label="شماره همراه" outlined readonly/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4">
          <label>کد تایید تاپ</label>
          <div class="d-flex align-center">
            <v-otp-input v-model="otpCode" autofocus length="4" style="direction: ltr" type="number"
                         @finish="verifyPhone"/>
            <v-btn class="mx-2" icon @click="otpCode = ''">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col class="pa-2 d-flex" cols="12">
          <v-btn :disabled="!phone || phone.length < 11 || phone.length > 11 || !phone.startsWith('09')"
                 :loading="loading" class="rounded-lg btn-get-code ma-0" depressed @click="verifyPhone">
            تایید
          </v-btn>
          <v-btn class="mx-2 rounded-lg" text @click="e6 = 1">
            بازگشت
          </v-btn>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
export default {
  name: "addTopPayment",

  data: () => ({
    e6: 1,
    flowToken: '',
    phone: '',
    nationalCode: '',
    otpCode: '',
    loading: false
  }),

  methods: {
    sendOtp() {
      if (!this.phone || this.phone.length < 11 || this.phone.length > 11 || !this.phone.startsWith('09'))
        return this.$toast.error('شماره به صورت صحیح وارد نمایید!')

      this.loading = true

      this.requestApiPost('top/otp', {
        phone: this.phone
      })
          .then(({data}) => {
            if (!!data?.data?.Message) this.$toast[data.data.Status === 0 ? 'success' : 'error'](data.data.Message)
            this.flowToken = data.data?.Data?.FlowToken
            this.e6 = 2
          })
          .catch(({response}) => console.log(response))
          .finally(() => this.loading = false)
    },
    verifyPhone() {
      this.loading = true

      this.requestApiPost('top/verify', {
        phone: this.phone,
        code: this.otpCode,
        nationalCode: this.nationalCode,
        token: this.flowToken
      })
          .then(({data}) => {
            if (!!data?.data?.Message) this.$toast[data.data.Status === 0 ? 'success' : 'error'](data.data.Message)
            // this.flowToken = data.data.Data.FlowToken
            this.e6 = 3
          })
          .catch(({response}) => console.log(response))
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>